function FormatCpf(cpf: string | undefined): string {
  cpf = cpf?.replace(/[^\d]/g, "");
  return cpf ? cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : "";
}

export default FormatCpf;
